/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Notification_Delivery_SuccessInputs */

const vi_notification_delivery_success = /** @type {(inputs: Notification_Delivery_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đơn ${i?.code} đã giao thành công`)
};

/**

* @param {Notification_Delivery_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notification_delivery_success = /** @type {((inputs: Notification_Delivery_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Delivery_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notification_delivery_success(inputs)
});